export default {
  type: {
    html: 'FragmentHtml',
    recipe: 'FragmentRecipe',
    sidebar: 'FragmentSidebar',
    pullout: 'FragmentPullout',
    embeds: 'FragmentEmbed',
    media: {
      image: 'FragmentPicture',
      gallery: 'FragmentGallery',
      audio: 'FragmentAudio',
      video: 'FragmentVideo',
      stream: 'FragmentVideo',
    },
    embed: {
      default: 'FragmentEmbed',
      custom: 'FragmentEmbed',
      quiz: 'FragmentQuiz',
      rembi: 'FragmentJsmk',
      liveblog: 'FragmentJsmk',
      dstream: 'FragmentDstream',
    },
  } as Record<string, any>,
};
